/**
 * HealthStatusBadge — heart / heart-break icon + text for the instance's
 * last health check verdict, used in the Overview tab's Instance summary.
 */
import React from 'react';
import { Heart, HeartBreak } from '@phosphor-icons/react';
import type { EnvironmentHealthStatus } from '../../../hooks/useEnvironmentInstances';

export interface HealthStatusBadgeProps {
  status: EnvironmentHealthStatus;
}

export function HealthStatusBadge({ status }: HealthStatusBadgeProps) {
  if (status === 'healthy') {
    return (
      <span className="inline-flex items-center gap-1 text-emerald-600">
        <Heart size={16} weight="fill" />
        <span className="font-medium">Healthy</span>
      </span>
    );
  }
  if (status === 'unhealthy') {
    return (
      <span className="inline-flex items-center gap-1 text-red-600">
        <HeartBreak size={16} weight="fill" />
        <span className="font-medium">Unhealthy</span>
      </span>
    );
  }
  return <span className="text-muted-foreground">Unknown</span>;
}

HealthStatusBadge.displayName = 'HealthStatusBadge';
